enum TheMachineTicketBook {
  Silver = 'silver',
  Gold = 'gold',
  Pressure = 'pressure'
}

function getTicketBookSequence(): TheMachineTicketBook[] {
  return [
    TheMachineTicketBook.Silver,
    TheMachineTicketBook.Gold,
    TheMachineTicketBook.Pressure
  ];
}

function getTicketBookNameForTicketBookId(prizeLevel: TheMachineTicketBook) {
  switch (prizeLevel) {
    case TheMachineTicketBook.Silver:
      return 'Silver';
    case TheMachineTicketBook.Gold:
      return 'Gold';
    case TheMachineTicketBook.Pressure:
      return 'Pressure';
  }
}

export { TheMachineTicketBook, getTicketBookSequence, getTicketBookNameForTicketBookId };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/the-machine/_domain/models/ticket-book.ts